/**
 * Buffer polyfill for the browser environment.
 *
 * @react-pdf/renderer (via fontkit) accesses the global `Buffer` synchronously
 * while subsetting/embedding fonts. A previous async (`await import('buffer')`)
 * implementation set the global too late, which surfaced as repeated
 * "Buffer is not defined" errors and corrupted font subsets
 * ("Offset is outside the bounds of the DataView").
 *
 * Importing statically guarantees `Buffer` is defined the moment this module is
 * evaluated, before React (and any PDF rendering) runs. `buffer` is aliased and
 * pre-bundled in vite.config.ts / optimizeDeps, so this resolves synchronously.
 */
import { Buffer as BufferPolyfill } from 'buffer';

if (typeof globalThis !== 'undefined' && !(globalThis as any).Buffer) {
    (globalThis as any).Buffer = BufferPolyfill;
}

if (typeof window !== 'undefined' && !(window as any).Buffer) {
    (window as any).Buffer = BufferPolyfill;
}

export { BufferPolyfill as Buffer };
